import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["block", "children", "checked", "onChange"];
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { CardContentWrapper } from '../CardContentWrapper';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { InputLabel } from '../Typography/InputLabel';
import { jsx as _jsx } from "react/jsx-runtime";
export const RadioCard = _ref => {
  let {
      block = true,
      children,
      checked,
      onChange
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  const handleChange = () => {
    onChange(!checked);
  };
  return /*#__PURE__*/_jsx(SelectableBox, Object.assign({}, rest, spacingProps, {
    block: block,
    onClick: handleChange,
    selected: checked,
    type: "radio",
    children: /*#__PURE__*/_jsx(CardContentWrapper, {
      children: children
    })
  }));
};
RadioCard.Label = InputLabel;